import React from 'react';

import ProductPrice from '../../product/components/product-price';
import { OptimizeProductImageWrapper } from '../../product/components/product-image';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import ProductOverview from './product-overview';
import AddToCart from './add-to-cart';
import SaleCallout from './sale-callout';

import '../css/gift-guide-product-card.less';

const GiftGuideProductCard = ({ key, onAdd, product }) => {
    //overview override
    const handleKeyUp = e => {
        e.preventDefault();
        let charCode = e.keyCode || e.which;
        if (charCode === 13) {
            //when enter is pressed
            onAdd();
        }
    };
    return (
        <div tabIndex={0} className="gift-guide-product-card" key={key}>
            <SaleCallout product={product} />
            <GiftGuideImage onClick={onAdd} product={product} imagesToShow={1} />
            <div className="product-details">
                <h3 aria-label={product.name} tabIndex={0} onKeyUp={handleKeyUp} onClick={onAdd}>
                    {product.name}
                </h3>
                <ProductPrice product={product} />
                <ProductOverview
                    overview={
                        product.metadata.mktDiff || product.attributes.prdOverview || (product.ksps || []).join(' • ')
                    }
                />
                <AddToCart openModal={onAdd} product={product} className="og" />
            </div>
        </div>
    );
};

const GiftGuideImage = OptimizeProductImageWrapper(({ images, onClick }) => (
    <div className="prod-img">
        <span className="center-utility"></span>
        <ImageWithPlaceholder tabIndex={0} src={images[0]} className="actual-image" onClick={onClick} />
    </div>
));

export default GiftGuideProductCard;
